var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{ref:"suc",attrs:{"title":"已提交"},on:{"close":_vm.handlerClose}},[(_vm.reviewers)?_c('p',{staticClass:"result-info"},[_vm._v("请等候"+_vm._s(_vm.reviewers)+"的审核")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }